var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChannelTimeSeries',_vm._b({attrs:{"title":_vm.title,"item-id":_vm.itemId}},'BaseChannelTimeSeries',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }